// src/components/ProcedureModal.jsx
import React, { useState } from 'react';

const ProcedureModal = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="procedure-button" onClick={() => setOpen(true)}>
        Процедура подачи заявок
      </button>

      {open && (
        <div className="reg-overlay" onClick={() => setOpen(false)}>
          <div className="reg-modal" onClick={e => e.stopPropagation()}>
            <button className="reg-close" onClick={() => setOpen(false)}>
              ×
            </button>

            <h2>ПРОЦЕДУРА ПОДАЧИ ЗАЯВОК</h2>
            <p className="reg-intro">
              (формат · дедлайны · правила участия)
            </p>

            <div className="reg-section">
              <div className="reg-table-wrapper">
                <table className="reg-table">
                  <thead>
                    <tr>
                      <th>Этап</th>
                      <th>Сроки (2025)</th>
                      <th>Что делает команда</th>
                      <th>Что проверяют организаторы</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1. Регистрация профиля</td>
                      <td>1 июля — 31 августа</td>
                      <td>
                        • Капитан создаёт аккаунт на платформе MAMI Connect.<br/>
                        • Заполняет личные данные (ФИО, LinkedIn, портфолио).<br/>
                        • Приглашает 2–5 участников, указывая их роли (стратег, дизайнер, тех‑лид, копирайтер и т. д.).
                      </td>
                      <td>
                        • Подтверждение уникальности e‑mail.<br/>
                        • Проверка соответствия возрастному порогу (18 +).
                      </td>
                    </tr>
                    <tr>
                      <td>2. Заполнение заявки</td>
                      <td>до 15 сентября 23:59 (EEST)</td>
                      <td>
                        Форма состоит из 6 блоков (на русском или английском):<br/>
                        1. Идея бренда — до 1 000 зн.;<br/>
                        2. Фокус‑рынки — 3 страны и обоснование;<br/>
                        3. ЦА и key‑insights (до 800 зн.);<br/>
                        4. Предв. логотип (SVG/PNG 4:1, ≤2 МБ);<br/>
                        5. Одностр. медиаплан (PDF, ≤5 МБ);<br/>
                        6. 60‑секундное видео‑обращение капитана (MP4, ≤100 МБ).
                      </td>
                      <td>
                        • Проверка формата файлов и лимитов.<br/>
                        • Антиплагиат (Similarity ≤20 %).<br/>
                        • Соответствие теме одного из треков (fashion/tech/social impact).
                      </td>
                    </tr>
                    <tr>
                      <td>3. Юридический блок</td>
                      <td>вместе с заявкой</td>
                      <td>
                        • Электронное согласие с Пользовательским соглашением и IP‑политикой.<br/>
                        • Подписать NDA о неразглашении чужих идей.<br/>
                        • Верификация цифровой подписи (DocuSign).
                      </td>
                      <td>—</td>
                    </tr>
                    <tr>
                      <td>4. Скрининг заявок</td>
                      <td>16 — 24 сентября</td>
                      <td>—</td>
                      <td>
                        • Технический комитет проверяет полноту данных и антиплагиат.<br/>
                        • Рейтингует идеи по чек‑листу (новизна, соответствие, жизнеспособность).
                      </td>
                    </tr>
                    <tr>
                      <td>5. Объявление short‑list</td>
                      <td>25 сентября</td>
                      <td>
                        • 60 лучших команд получают уведомление на e‑mail и в кабинете.<br/>
                        • Подтверждают участие (кнопка «I’m in»).<br/>
                        • Если не подтвердят за 72 ч — место переходит в лист ожидания.
                      </td>
                      <td>—</td>
                    </tr>
                    <tr>
                      <td>6. Подготовительный буткемп (онлайн)</td>
                      <td>1 — 20 октября</td>
                      <td>
                        • Участие не обязательно, но даёт +5 баллов.<br/>
                        • Вебинары с менторами, шаблоны pitch‑deck.<br/>
                        • Фиксация посещаемости (≥70 % = бонус).
                      </td>
                      <td>—</td>
                    </tr>
                    <tr>
                      <td>7. Финальный аплоад пакета</td>
                      <td>31 октября 18:00 (EEST)</td>
                      <td>
                        • Финальный brand‑book (PDF, ≤10 МБ);<br/>
                        • Видео‑питч 3 мин (MP4, ≤250 МБ);<br/>
                        • Медиа-файлы (логотипы, key‑visuals, mock‑ups).<br/>
                        Имя и персоналии скрыты (ID‑код).
                      </td>
                      <td>
                        • Контроль анонимности (очистка метаданных).<br/>
                        • Тестовый прогон видео‑плеера.
                      </td>
                    </tr>
                    <tr>
                      <td>8. 48‑часовой хакатон</td>
                      <td>1 — 3 ноября</td>
                      <td>
                        • TeamSpace + общий Stage для эфиров.<br/>
                        • Доступ к Figma, Miro, Google Colab.<br/>
                        • Стендапы с менторами (каждые 6 ч).<br/>
                        • Техподдержка 24/7 (latency ≤20 с).
                      </td>
                      <td>—</td>
                    </tr>
                    <tr>
                      <td>9. Live‑питч</td>
                      <td>3 ноября 18:00 — 21:00</td>
                      <td>
                        • Презентация (5 мин) + Q&A (3 мин).<br/>
                        • Можно screen‑share прототип.<br/>
                        • Запись питчей для повторного просмотра.
                      </td>
                      <td>—</td>
                    </tr>
                    <tr>
                      <td>10. Оценка и объявления</td>
                      <td>до 5 ноября</td>
                      <td>—</td>
                      <td>
                        • Эксперты заполняют оценочные листы.<br/>
                        • Подведение итогов, публикация рейтингов и feedback‑репортов.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="reg-section">
              <h3>Ключевые правила</h3>
              <ul className="brandhackathon__list">
                <li>Команда: 3–6 человек, капитаном может быть только маркетолог с опытом ≥3 лет.</li>
                <li>Одна заявка — одна идея. Повторные заявки отклоняются.</li>
                <li>Анонимизация: до Live‑питча судьи видят только ID‑коды.</li>
                <li>Язык работы: русский или английский; дублирование по желанию.</li>
<li>Отбор: ≥60 баллов — проход; &lt;60 — отклонение.</li>

                <li>Кодекс этики: запрещён hate‑speech, дискриминация, пропаганда.</li>
                <li>Права на результаты: авторские права у команд; МАМИ — опцион на 6 мес.</li>
                <li>Нарушение дедлайнов = дисквалификация без возврата кворума.</li>
                <li>Следуйте этим шагам, чтобы 15 сентября в полночь попасть в топ‑60!</li>
              </ul>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default ProcedureModal;
